import { JxtTagColorsEnum } from '@jooxter/utils';

export const contextualToneClasses: Record<JxtTagColorsEnum, { background: string; eyebrow: string; notice: string }> =
  {
    [JxtTagColorsEnum.BLUE]: { background: 'bg-primary-10', eyebrow: 'text-primary-110', notice: 'text-primary-140' },
    [JxtTagColorsEnum.ORANGE]: { background: 'bg-orange-10', eyebrow: 'text-orange-140', notice: 'text-orange-140' },
    [JxtTagColorsEnum.RED]: { background: 'bg-red-10', eyebrow: 'text-red-140', notice: 'text-red-140' },
    [JxtTagColorsEnum.GREEN]: { background: 'bg-green-10', eyebrow: 'text-green-140', notice: 'text-green-140' },
    [JxtTagColorsEnum.NEUTRAL]: {
      background: 'bg-neutral-10',
      eyebrow: 'text-neutral-120',
      notice: 'text-neutral-120',
    },
  };
